import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {Box, FormControlLabel, FormGroup, FormLabel, TextField, Stack, Grid} from "@mui/material";
import React, {useCallback, useEffect} from "react";
import {getData} from "../util/__fetch";

// Helper function to filter and prepare data for posting
export const getSelectedActiveUsers = (users) => {
  return users?.filter(u => u.active) || [];
};

export default function FNOUsersCheckbox({ user, selectedUsers, setSelectedUsers, allUsers, setAllUsers, setErrorMessage, type }) {
  const [localStorageVarName] = React.useState(type === "SELL" ?'fno_selected_users_sell' : 'fno_selected_users_buy');
  const [userLotMap, setUserLotMap] = React.useState(new Map());

  // Load selectedUsers from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(localStorageVarName);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          // Ensure lots property exists
          const usersWithLots = parsed.map(u => ({ ...u, lots: u.lots || 1 }));
          setSelectedUsers(usersWithLots);
        }
      } catch {}
    }
  }, [setSelectedUsers, localStorageVarName]);

  const fetchAllUsers = useCallback((dbUsers) => {
    // Merge DB users with LocalStorage to preserve selection state
    let storedUsers = [];
    try {
      const stored = localStorage.getItem(localStorageVarName);
      if (stored) storedUsers = JSON.parse(stored);
    } catch (e) { console.error(e); }

    const mergedUsers = dbUsers.map(u => {
      const stored = storedUsers.find(su => su.userId === u.userId);
      return {
        ...u,
        active: stored ? stored.active : false,
        lots: stored ? (stored.lots || 1) : 1
      };
    });
    setAllUsers(mergedUsers);
    setSelectedUsers(mergedUsers);
  }, [setAllUsers, setSelectedUsers, localStorageVarName]);

  // Save selectedUsers to localStorage whenever it changes
  useEffect(() => {
    if (selectedUsers && selectedUsers.length > 0) {
      localStorage.setItem(localStorageVarName, JSON.stringify(selectedUsers));
    }
  }, [selectedUsers, localStorageVarName]);

  useEffect(() => {
    getData('/algo-trading/api/fno/active/users', user, fetchAllUsers, setErrorMessage, () => {})
      .then(response => { });
  }, [user, fetchAllUsers, setErrorMessage]);

  function switchUserStatus(event, userId) {
    const newUsers = allUsers.map(us => us.userId === userId ? { ...us, active: !us.active } : us);
    setSelectedUsers(newUsers);
    setAllUsers(newUsers)
  }

  function handleLotsChange(event, userId) {
    const value = event.target.value;
    if (value === '') {
        const newUsers = allUsers.map(us => us.userId === userId ? { ...us, lots: '' } : us);
        setSelectedUsers(newUsers);
        setAllUsers(newUsers);
        return;
    }
    const newLots = parseInt(value, 10);
    if (!isNaN(newLots) && newLots > 0) {
      const newUsers = allUsers.map(us => us.userId === userId ? { ...us, lots: newLots } : us);
      setSelectedUsers(newUsers);
      setAllUsers(newUsers)
    }
  }

  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl sx={{ m: 0.5}} component="fieldset" variant="standard">
        <FormLabel component="legend">FNO {type} Users</FormLabel>
          <Box key={0} component="span" display="flex" flexDirection="row" sx={{ gap: 0.5 }}>
            {allUsers?.map((u) => (
                <>
                        <FormControlLabel
                          control={<Checkbox size="medium" checked={u.active || false} onChange={(e) => switchUserStatus(e, u?.userId)} />}
                          label={`${u?.fullName} (${u?.userId})`}  />
                        <TextField
                          label="Lots"
                          type="number"
                          size="small"
                          variant="outlined"
                          value={u.lots}
                          onChange={(e) => handleLotsChange(e, u.userId)}
                          sx={{ mr: 1.5, width: '80px' }}
                        />
                        </>
            ))}
        </Box>
      </FormControl>
    </Box>
  );
}